export default __webpack_public_path__ + "static/media/Panel-documentation.91231f7c.md";